import Vue from 'vue'
import IdleVue from 'idle-vue'

const eventsHub = new Vue()

export default function (context) {
  Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store: context.store,
    idleTime: 900000,
    startAtIdle: false,
  })
}
